<template>
    <mdb-navbar color="white" class="border-bottom fixed-top" light>
        <mdb-navbar-brand>
            <router-link to="/" class="text-dark">Verkkolabra</router-link>
        </mdb-navbar-brand>
        <mdb-navbar-toggler right>
            <mdb-navbar-nav right>
                <router-link to="/websites" class="pink-text">
                    <mdb-nav-item>{{ msg.websites }}</mdb-nav-item>
                </router-link>
                <router-link to="/mobileapps" class="pink-text">
                    <mdb-nav-item>{{ msg.mobileapps }}</mdb-nav-item>
                </router-link>
                <router-link to="/maintenance" class="pink-text">
                    <mdb-nav-item>{{ msg.maintenance }}</mdb-nav-item>
                </router-link>
                <!--<router-link to="/solutions" class="pink-text">
                    <mdb-nav-item>{{ msg.solutions }}</mdb-nav-item>
                </router-link>-->
                <router-link to="/story" class="pink-text">
                    <mdb-nav-item>{{ msg.story }}</mdb-nav-item>
                </router-link>
                <router-link to="/contact" class="pink-text">
                    <mdb-nav-item>{{ msg.contact }}</mdb-nav-item>
                </router-link>
            </mdb-navbar-nav>
        </mdb-navbar-toggler>
    </mdb-navbar>
</template>

<script>
    import { lang } from './../language';
    import {
        mdbNavbar,
        mdbNavbarBrand,
        mdbNavbarToggler,
        mdbNavbarNav,
        mdbNavItem,
        mdbDropdown,
        mdbDropdownMenu,
        mdbDropdownToggle,
        mdbInput,
        mdbDropdownItem,
        mdbFormInline
    } from 'mdbvue';

    export default {
        name: 'Navbar',
        components: {
            mdbNavbar,
            mdbNavbarBrand,
            mdbNavbarToggler,
            mdbNavbarNav,
            mdbNavItem,
            mdbDropdown,
            mdbDropdownMenu,
            mdbDropdownToggle,
            mdbDropdownItem,
            mdbFormInline,
            mdbInput
        },
        data() {
            return {
                msg: null,
            }
        },
        created() {
            this.msg = lang.app.nav;
        },
    }
</script>

<style scoped>
    .navbar {
        box-shadow: none;
    }

    .navbar-toggler-icon {
        border-color: black !important;
    }
</style>
